import { FC, memo } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import "./RadioButton.scss";

type RadioButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  name: string;
  value: string;
  className?: string;
  onChange: (event: any) => void;
  disabled?: boolean;
  checked?: boolean;
};
const RadioButton: FC<RadioButtonProps> = ({
  name,
  value,
  className = "",
  onChange,
  disabled = false,
  checked = false
}: RadioButtonProps) => {
  return (
    <RadioGroup
      row
      aria-labelledby="demo-row-radio-buttons-group-label"
      name="controlled-radio-buttons-group"
      onChange={onChange}
    >
      <FormControlLabel
        value={value}
        control={
          <Radio
            id={name}
            value={value}
            className={className}
            checked={checked}
            disabled={disabled}
          />
        }
        label={name}
      />
    </RadioGroup>
  );
};

export default memo(RadioButton);
